const configuredApiBase = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL;

function normalizeConfiguredApiBase(rawBase) {
  const base = (rawBase || '').trim();
  if (!base) return '';

  if (typeof window === 'undefined') return base;

  const isHttpsPage = window.location.protocol === 'https:';
  const isLocal = /localhost|127\.0\.0\.1/.test(base);

  if (isHttpsPage && base.startsWith('http://') && !isLocal) {
    return base.replace(/^http:\/\//i, 'https://');
  }

  return base;
}

function getDefaultApiBase() {
  if (typeof window === 'undefined') {
    return 'http://localhost:5000';
  }

  const currentHost = window.location.hostname;
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // Em produção, se não houver REACT_APP_API_URL explícita, 
  // usamos o próprio domínio para aproveitar o proxy do Nginx.
  // Isso evita problemas de CORS e IPs dinâmicos.
  return window.location.origin;
}

export const API_BASE = normalizeConfiguredApiBase(configuredApiBase) || getDefaultApiBase();
